import {
    Component,
    Inject, OnInit,
    Optional,
    Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ClienteService } from "app/main/services/cliente.service";

@Component({
    selector: "link-relacionado-dialog-box",
    templateUrl: "./link-relacionado-dialog-box.component.html",
    styleUrls: ["./link-relacionado-dialog-box.component.scss"],
})
export class LinkRelacionadoDialogBoxComponent implements OnInit{

    estados = [
        { nombre: "Confirmado", value: "CONFIRMADO" },
        { nombre: "Rechazado", value: "RECHAZADO" },
    ];

    estado: string;
    LOCAL_DATA: any;

    constructor(
        private roleService: RoleService,
        private _snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<LinkRelacionadoDialogBoxComponent>,
        public translate: TranslateService,
        private clienteService: ClienteService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.LOCAL_DATA = { ...data };
    }

    modificarEstado() {

        this.clienteService.editLinkRelacionadoStatus(this.LOCAL_DATA.clienteId,this.LOCAL_DATA.id, this.estado).pipe()
            .subscribe((req) => {
                const status = req.status;
                if (status === 202) {
                    this.openSnackBar("Estado actualizado correctamente", "Cerrar");
                    this.dialogRef.close({ event: 'Update', data: this.estado });
                } else {
                    this.openSnackBar("Error al actualizar el estado", "Cerrar");
                    this.dialogRef.close({ event: 'Cancel'});
                }
            });

    }


    closeDialog(): void {
        this.dialogRef.close({ event: "Cancel" });
    }

    openDialog(): void {}

    ngOnInit(): void {
        // Select the first value by default
        this.estado = this.estados[0].value;
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }
}
